/* ==========================================================================
   OliveDrab — arrows on the scrolling strips

   A row that scrolls sideways reads as a finished row unless something says
   otherwise, and most people never try the swipe. This puts a prev and next
   arrow on any strip that actually overflows, and takes them away again when
   it does not — on a resize, or when the row is short enough to fit.

   Strips that already carry their own nav (the rails, which have arrows in
   the heading) are left alone.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var ARROW = {
    prev: 'M10.5 3.5 6 8l4.5 4.5',
    next: 'M5.5 3.5 10 8l-4.5 4.5'
  };

  function button(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'od-strip__arrow od-strip__arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML =
      '<span class="od-strip__arrow-face" aria-hidden="true">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="' + ARROW[dir] + '"/></svg></span>';
    return b;
  }

  function bind(strip) {
    if (strip.dataset.odStripNav) return;

    var track = $('.od-strip__track', strip);
    if (!track) return;

    /* a rail brings its own arrows in the heading; two sets would be noise */
    var owner = strip.closest('section') || strip;
    if ($('.od-rail__nav', owner)) return;

    /* a drifting row moves on its own and has no scroll position to nudge */
    if (strip.classList.contains('od-strip--drift')) return;

    strip.dataset.odStripNav = '1';

    var prev = button('prev', 'Previous');
    var next = button('next', 'Next');
    strip.appendChild(prev);
    strip.appendChild(next);

    function step() {
      var tile = $('.od-cthumb, .od-strip__track > *', track);
      var one = tile ? tile.getBoundingClientRect().width + 14 : 140;
      return Math.max(one, track.clientWidth * 0.8);
    }

    function sync() {
      var room = track.scrollWidth - track.clientWidth;
      var scrolls = room > 4;
      strip.classList.toggle('has-arrows', scrolls);
      if (!scrolls) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= room - 2;
    }

    function go(by) {
      if (track.scrollTo) {
        track.scrollTo({ left: track.scrollLeft + by, behavior: 'smooth' });
      } else {
        track.scrollLeft += by;
      }
    }

    var loop = strip.hasAttribute('data-od-strip-loop');

    if (loop) { bindLoop(); return; }

    prev.addEventListener('click', function () { go(-step()); });
    next.addEventListener('click', function () { go(step()); });
    track.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync, { passive: true });
    }

    sync();

    /* ---- a row that loops: three copies, always started on the middle ---- */
    function bindLoop() {
      strip.classList.add('has-arrows');

      function tile() {
        var t = $('.od-cthumb', track);
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return t ? t.getBoundingClientRect().width + gap : 150;
      }
      function setWidth() { return track.scrollWidth / 3; }

      /* moved by a whole set, instantly, so nothing is seen to jump */
      function jump(by) {
        var was = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += by;
        track.style.scrollBehavior = was;
      }
      function wrap() {
        var w = setWidth();
        if (!w) return;
        if (track.scrollLeft < w * 0.5) jump(w);
        else if (track.scrollLeft > w * 1.5) jump(-w);
      }

      function place() { var w = setWidth(); if (w) jump(w - track.scrollLeft); }

      var settle = null;
      track.addEventListener('scroll', function () {
        window.clearTimeout(settle);
        settle = window.setTimeout(wrap, 140);
      }, { passive: true });

      /* ---- its own clock: one tile at a time, never stopped by a resting cursor ---- */
      var seconds = parseFloat(strip.getAttribute('data-loop-seconds')) || 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var held = {};
      var timer = null;
      function running() {
        if (!seconds || reduce) return false;
        for (var k in held) if (held[k]) return false;
        return true;
      }
      function schedule() {
        window.clearTimeout(timer);
        if (!running()) return;
        timer = window.setTimeout(function () { go(tile()); schedule(); }, seconds * 1000);
      }
      function hold(why, on) { held[why] = on; if (on) window.clearTimeout(timer); else schedule(); }

      prev.disabled = false;
      next.disabled = false;
      prev.addEventListener('click', function () { go(-tile()); schedule(); });
      next.addEventListener('click', function () { go(tile()); schedule(); });

      /* a hand on the row takes it over, and hands it back after a rest */
      var resume = null;
      track.addEventListener('pointerdown', function () { window.clearTimeout(resume); hold('hand', true); });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        track.addEventListener(ev, function () {
          window.clearTimeout(resume);
          resume = window.setTimeout(function () { hold('hand', false); }, 2500);
        });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { hold('away', !e.isIntersecting); });
        }, { threshold: 0 }).observe(strip);
      }
      document.addEventListener('visibilitychange', function () { hold('hidden', document.hidden); });

      /* widths are only known once the section is laid out */
      if ('ResizeObserver' in window) {
        var first = true;
        new ResizeObserver(function () {
          if (!track.clientWidth) return;
          if (first) { place(); first = false; } else { wrap(); }
        }).observe(track);
      } else {
        place();
      }
      schedule();
    }
  }

  function boot(scope) { $$('.od-strip', scope || document).forEach(bind); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
